var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"containerRef",staticClass:"big-screen-wrapper"},[_c('div',{ref:"mainRef",staticClass:"main-wrapper"},[_vm._t("main")],2),_c('div',{ref:"layerRef",staticClass:"layer-wrapper"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }